// schema
import * as ISchema from "@schema";

// util
import {
  FlagNamespaces,
  UserFlags,
  isFlagSet,
  Flag,
} from "@clockwise/client-commons/src/util/flags";

// state
import { WeekViewCurrentTip } from "@actions/week-view.actions";
import { Environment } from "relay-runtime";
import { updateFlagsForUser } from "@mutations";

export const weekViewTipOrder = [
  WeekViewCurrentTip.None,
  WeekViewCurrentTip.Autopilot,
  WeekViewCurrentTip.TeamEvent,
  WeekViewCurrentTip.EventDetails,
  WeekViewCurrentTip.ColorCoding,
  WeekViewCurrentTip.AutopilotSettings,
];

export const weekViewTipFlagMap = {
  [WeekViewCurrentTip.Autopilot]: UserFlags.Onboarding.HasSeenWeekViewAutopilotTooltip.name,
  [WeekViewCurrentTip.TeamEvent]: UserFlags.Onboarding.HasSeenWeekViewTeamEventTooltip.name,
  [WeekViewCurrentTip.EventDetails]: UserFlags.Onboarding.HasSeenWeekViewEventDetailsTooltip.name,
  [WeekViewCurrentTip.ColorCoding]: UserFlags.Onboarding.HasSeenWeekViewColorCodingTooltip.name,
  [WeekViewCurrentTip.AutopilotSettings]:
    UserFlags.Onboarding.HasSeenWeekViewAutopilotSettingsTooltip.name,
};

export function getNextWeekViewTip(
  flagsErrorable: ISchema.FlagsErrorable,
  prevTip: WeekViewCurrentTip,
) {
  if (
    !isFlagSet(UserFlags.Onboarding.ShouldSeeWeekViewTooltips.name, flagsErrorable) ||
    isFlagSet(UserFlags.Onboarding.HasSeenAllWeekViewTooltips.name, flagsErrorable)
  ) {
    return WeekViewCurrentTip.None;
  }

  let currentIndex = weekViewTipOrder.indexOf(prevTip);

  if (currentIndex + 1 >= weekViewTipOrder.length) {
    return WeekViewCurrentTip.None;
  }

  let nextTip = weekViewTipOrder[++currentIndex];

  while (
    nextTip !== WeekViewCurrentTip.None &&
    isFlagSet(weekViewTipFlagMap[nextTip], flagsErrorable) &&
    currentIndex < weekViewTipOrder.length
  ) {
    currentIndex += 1;

    if (currentIndex < weekViewTipOrder.length) {
      nextTip = weekViewTipOrder[currentIndex];
    } else {
      nextTip = WeekViewCurrentTip.None;
    }
  }

  return nextTip;
}

export function updateWeekViewFlags(
  environment: Environment,
  tip: WeekViewCurrentTip,
): Promise<void> {
  if (tip === WeekViewCurrentTip.None) {
    return Promise.resolve();
  }

  const flagNames: Flag[] = [weekViewTipFlagMap[tip]];

  if (weekViewTipOrder.indexOf(tip) === weekViewTipOrder.length - 1) {
    flagNames.push(UserFlags.Onboarding.HasSeenAllWeekViewTooltips.name);
  }

  return new Promise((resolve, reject) => {
    updateFlagsForUser(
      environment,
      {
        flagNames,
        flagNamespace: FlagNamespaces.Webapp,
        enable: true,
      },
      () => resolve(),
      () => reject(),
    );
  });
}

export {
  FlagNamespaces,
  UserFlags,
  validateFlagsErrorable,
  isFlagSet,
  isUserAtLeastXDaysOld,
} from "@clockwise/client-commons/src/util/flags";
